import React from 'react';

import styles from './styles.module.css';

const MidnightIndicator = ({ dateRange }) => {
	const totalDays = dateRange.length;

	if (totalDays < 2) return null;

	return dateRange.slice(1).map((_, index) => {
		const leftPosition = ((index + 1) / totalDays) * 100;

		return (
			<div
				key={`midnight-${index}`}
				data-testid="midnight-indicator"
				className={styles.midnightIndicator}
				style={{ left: `${leftPosition}%` }}
			/>
		);
	});
};

export default MidnightIndicator;
